import styled from 'styled-components'

export const AssetSelectorStyledContianer = styled.div`
    position: fixed;
    /* top: 0; */
    /* left: 0; */
    border: 1px solid var(--gray-500);
    border-radius: 4px;
    height: calc(100% - 172px);
    width: 210px;
    margin-top: 32px;

    div.title {
        padding: 8px;
        font-size: 13px;
        text-transform: uppercase;
        font-family: var(--font-bold);
    }

    > div:nth-child(2) {
        padding: 0 8px 8px 8px;

        border-bottom: 1px solid var(--gray-500);
    }

    .ScrollbarsCustom {
        .ScrollbarsCustom-Wrapper {
            div.asset {
                padding: 8px 8px 8px 16px;
                cursor: pointer;

                &.selected {
                    background: var(--gray-100);
                }

                &:hover {
                    position: relative;
                    background: var(--blue-200);

                    &::after {
                        position: absolute;
                        top: 0;
                        left: 0;
                        content: '';
                        width: 5px;
                        height: 100%;
                        background: var(--blue-500);
                    }
                }

                &:not(:last-child) {
                    border-bottom: 1px solid var(--gray-500);
                }

                div.asset-type {
                    font-family: var(--font-bold);
                    color: var(--gray-700);
                }

                div.asset-name {
                    font-family: var(--font-bold);
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .ScrollbarsCustom-Track.ScrollbarsCustom-TrackY {
            top: 0 !important;
            height: 100% !important;
        }
    }
`
